import { weappSDK } from ".";
import { getSecondPathUrl } from "../open";
import { getNameFromUrl } from "../request";
import { ua } from "../ua";
import openRoute from './openRoute';
import history from "../history-plugin/history";



export type OpenType = 'open' | 'href' | 'route' | 'iframe' | 'form';

export function webOpen(url: string, openType: OpenType = 'open') {
  const type = openType;
  // 系统统一开关
  // if (window.e9mobileConfig && window.e9mobileConfig.openLinkType) {
  //   type = window.e9mobileConfig.openLinkType;
  // }
  if (type === 'href') {
    if(url.match(/^\//)){
      url = getSecondPathUrl(url);
      /**
       *  下面代码未兼容 当对应的地址已经带了二级路径的api的场景 /{second}/api/file ->
       *    条件 1 不匹配。 并且不以api接口开头 误判为静态资源请求, 会额外写带前端二级路径变量
       */
      
      // const moduleName = getNameFromUrl(url);
      // // 打开本站的地址 并且属于 /spai /api /papi的情况下 获取对应模块标识 取响应模块变量
      // if(moduleName){
      //   const apiBaseURL: string = window[`apiUrlweapp${moduleName}`] || window.publicUrlapi || window.publicUrl || ''; // 
      //   if(apiBaseURL){
      //     url = apiBaseURL + url;
      //   }
      // } else{
      //   // 以/开头且非api接口 拼接前端二级路径
      //   const publicUrlstatic = window.publicUrlstatic || window.publicUrl || '';
      //   if(publicUrlstatic){
      //     // 模块手动拼接了二级路径的情况
      //     const reg = new RegExp(`^${publicUrlstatic}`);
      //     // 未匹配的情况下拼接二级路径
      //     if (!url.match(reg)) {
      //       url = publicUrlstatic + url;
      //     }
      //   }
      // }
    }
    window.location.href = url;
  } else if (type === 'route') {
    history.push(url);
    return {
      close: function () {
        window.history && window.history.go(-1);
      }
    };
  } else if (type === 'iframe') {
    var frameView = document.createElement("div");
    frameView.style.position = "fixed";
    frameView.style.width = "100%";
    frameView.style.height = "100%";
    frameView.style.top = '0px';
    frameView.style.left = '0px';
    frameView.style.zIndex = '998';
    frameView.innerHTML = '<iframe style="border:none;height:100%;width:100%" src="' + url + '"></iframe>';
    document.body.appendChild(frameView);
    return {
      close: function () {
        document.body.removeChild(frameView)
      }
    }
  } else if (type === "form") {
    var form = document.createElement("form");
    form.setAttribute("style", "display:none");
    form.setAttribute("method", "get");
    form.setAttribute("action", url);
    form.setAttribute("target", "");
    var input = document.createElement("input");
    input.setAttribute("name", "test");
    input.setAttribute("value", "download");
    document.body.appendChild(form);
    form.appendChild(input);
    form.submit();
  } else {
    // 单独处理飞书逻辑移除, 已经默认组件公共底层默认处理window.open方法 
    return window.open(url);
  }
}

function openLink(url: string, type: OpenType) {
  if (weappSDK.checkApi('openLink')) {
    weappSDK.exec('openLink', { rl: url, openType: type });
  } else {
    webOpen(url, type);
  }
}

export default openLink;
